import { Cart, CartSetBillingAddressAction } from "@commercetools/platform-sdk"
import { BillingAddressForm, JOGGResponse } from "@jog/types"

import { handleCartError } from "../helper"
import { JoggApiOption } from "./client"

export const addBillingAddressBase = ({ client }: Pick<JoggApiOption, "client">) => {
    return async (cartId: string, version: number, billingAddress: BillingAddressForm): Promise<JOGGResponse<Cart>> => {
        const action: CartSetBillingAddressAction = {
            action: "setBillingAddress",
            address: {
                country: billingAddress.country,
                firstName: billingAddress.name,
                lastName: `${billingAddress.insertion || ""} ${billingAddress.familyName}`.trim(),
                postalCode: billingAddress.postalCode,
                streetNumber: billingAddress.houseNumber,
                streetName: billingAddress.streetName,
                city: billingAddress.city,
                additionalStreetInfo: billingAddress.addition,
                phone: billingAddress.phoneNumber,
                email: billingAddress.email,
            },
        }
        const request = (version: number) =>
            client.execute({
                method: "POST",
                uri: `/ctp/carts/${cartId}`,
                body: {
                    version: version,
                    actions: [action],
                },
            })
        return handleCartError(request, version, 5)
    }
}
